function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "noun_cool_3856524",
  transform: "translate(-31 0.1)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_11952",
  "data-name": "Path 11952",
  fill: "#81e2a6",
  d: "M34.22,22.949a.341.341,0,0,0,.564.385l.313-.459v1a.341.341,0,1,0,.683,0V15.341a.341.341,0,0,0-.683,0v1l-.313-.459a.341.341,0,0,0-.564.385l.877,1.285V18.8l-.908-.885L33.879,16.4a.341.341,0,0,0-.669.137l.109.531-.595-.58a.342.342,0,0,0-.477.489l.568.554-.529-.1a.341.341,0,1,0-.131.67l1.553.3.893.871H33.329l-1.32-.859a.342.342,0,0,0-.373.572l.441.287h-.736a.341.341,0,0,0,0,.683h.736l-.441.287a.342.342,0,0,0-.1.473.345.345,0,0,0,.473.1l1.32-.859H34.6l-.893.87-1.553.3a.341.341,0,0,0,.131.67l.529-.1-.568.554a.342.342,0,1,0,.477.489l.595-.58-.109.53a.343.343,0,1,0,.669.137l.311-1.517.908-.885v1.244Z",
  transform: "translate(0 -12.439)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11953",
  "data-name": "Path 11953",
  fill: "#81e2a6",
  stroke: "#81e2a6",
  strokeWidth: "0.2px",
  d: "M55.632,14.419V1.707a1.707,1.707,0,1,0-3.415,0V14.419a3.927,3.927,0,1,0,3.415,0Zm-1.707,6.752a3.227,3.227,0,0,1-1.236-6.215.341.341,0,0,0,.212-.316V1.707a1.024,1.024,0,0,1,2.049,0V2.9h-.683a.341.341,0,1,0,0,.683h.683v.683h-.341a.341.341,0,1,0,0,.683h.341v.683h-.683a.341.341,0,1,0,0,.683h.683V7h-.341a.341.341,0,1,0,0,.683h.341v.683h-.683a.341.341,0,1,0,0,.683h.683v.683h-.341a.341.341,0,1,0,0,.683h.341V14.64a.341.341,0,0,0,.212.316,3.227,3.227,0,0,1-1.236,6.215Z",
  transform: "translate(-15.754)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11954",
  "data-name": "Path 11954",
  fill: "#81e2a6",
  d: "M65.048,72.644v-4.3a.341.341,0,0,0-.683,0v4.3a1.707,1.707,0,1,0,.683,0Z",
  transform: "translate(-26.536 -56.39)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11955",
  "data-name": "Path 11955",
  fill: "#81e2a6",
  d: "M88.542,34.312a.34.34,0,0,0-.349,0V31.341a.341.341,0,1,0-.683,0v2.968a.34.34,0,0,0-.462.472l.512.836a.341.341,0,0,0,.582,0l.512-.836A.341.341,0,0,0,88.542,34.312Z",
  transform: "translate(-46.437 -25.707)"
}));

var SvgThermometer = function SvgThermometer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11.268,
    height: 22.082,
    viewBox: "0 0 11.268 22.082",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgThermometer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/thermometer.3948d9cb.svg";
export { ForwardRef as ReactComponent };